import { ClipboardCheckIcon, StarIcon } from 'lucide-react';
import { FC } from 'react';

import { useIsBetaFeatureEnabled } from '@/entities/beta-feature';
import { usePinnedDashboardPresetRoutes } from '@/entities/settings';
import { SidebarNavItem } from '@/shared/ui';

/**
 * Динамическое подменю закреплённых дашбордов-пресетов под группой «Контроль».
 *
 * Пункт ведёт на адрес раздела своего пресета; активность считает `SidebarNavItem` по общему
 * правилу меню, сам пресет применяет адрес (`useDashboardPresetSectionSync`). При выключенной
 * бета-функции пользовательских дашбордов пунктов нет вовсе — закреплённые пресеты остаются в
 * настройках пользователя и вернутся вместе с функцией.
 */
export const DashboardPresetsDynamicMenu: FC = () => {
  const isPresetsEnabled = useIsBetaFeatureEnabled('CUSTOM_DASHBOARDS');
  const pinnedRoutes = usePinnedDashboardPresetRoutes();

  if (!isPresetsEnabled || pinnedRoutes.length === 0) {
    return null;
  }

  return (
    <>
      {pinnedRoutes.map(({ preset, path }) => (
        <SidebarNavItem
          key={preset.id}
          path={path}
          icon={
            <span className="relative flex size-4 shrink-0">
              <ClipboardCheckIcon size={16} strokeWidth={1.25} />
              {/* Звезда закрепления сдвинута в угол значка — тело значка остаётся читаемым */}
              <span className="absolute -right-1 -bottom-1 flex items-center justify-center">
                <StarIcon size={8} strokeWidth={2.5} className="fill-current" />
              </span>
            </span>
          }
          label={preset.name}
          tooltip={preset.name}
        />
      ))}
    </>
  );
};
